<template>
  <div class="w-full">
    <Panel header="Quản lý nhận góp ý">
      <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
        <section class="md:col-span-12">
          <div class="rounded-lg border border-slate-200 bg-white p-4">
            <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
              <div class="flex min-w-0 flex-col md:col-span-5 lg:col-span-4">
                <label>Chọn thành viên</label>
                <Dropdown
                  v-model="managerFb.zaloId"
                  :options="listCustomer"
                  optionLabel="name"
                  optionValue="id"
                  placeholder="Chọn tài khoản"
                  :filter="true"
                >
                  <template #option="slotProps">
                    <div class="flex items-center gap-2">
                      <img
                        v-if="slotProps.option.imageUrl"
                        :src="slotProps.option.imageUrl"
                        class="mr-1 h-5 w-5 rounded object-cover"
                      />
                      <label class="m-0 font-medium text-slate-800">{{
                        slotProps.option.name
                      }}</label>
                    </div>
                  </template>
                </Dropdown>
              </div>
              <div class="flex min-w-0 flex-col md:col-span-3 lg:col-span-2">
                <label>Thêm</label>
                <Button
                  label="Thêm"
                  icon="pi pi-plus-circle"
                  iconPos="left"
                  @click="addMember()"
                  :loading="addingManager"
                  :disabled="!managerFb.zaloId"
                />
              </div>
            </div>
          </div>
        </section>

        <section class="md:col-span-12">
          <div
            class="overflow-hidden rounded-lg border border-slate-200 bg-white"
          >
            <div
              class="border-b border-slate-200 bg-slate-50 px-4 py-3 text-[15px] font-bold text-slate-900"
            >
              Danh sách thành viên nhận góp ý
            </div>

            <div class="p-4">
              <DataTable
                :loading="isLoading"
                :value="listManagerFb"
                :paginator="true"
                stripedRows
                :rows="10"
                :rowsPerPageOptions="[10, 25, 50]"
                :rowHover="true"
                v-model:filters="filters"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                :globalFilterFields="['zaloName']"
                currentPageReportTemplate="Có tổng số {totalRecords} thành viên"
                columnResizeMode="fit | expand"
              >
                <template #header>
                  <div
                    class="flex flex-wrap items-center justify-between gap-3"
                  >
                    <div class="flex items-center gap-3">
                      <Button
                        type="button"
                        icon="pi pi-filter-slash"
                        label="Xoá lọc"
                        outlined
                        @click="clearFilter()"
                      />
                      <span class="relative flex w-full">
                        <i
                          class="pi pi-search pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-slate-400"
                        />
                        <InputText
                          class="!w-[400px] !pl-8 !pr-3"
                          v-model="filters['global'].value"
                          placeholder="Tìm theo tên hoặc số điện thoại"
                        />
                      </span>
                    </div>
                  </div>
                </template>

                <Column field="zaloName" header="Họ và tên" sortable></Column>
                <Column header="Hành động">
                  <template #body="slotProps">
                    <Button
                      severity="danger"
                      label="Xoá"
                      icon="pi pi-trash"
                      @click="deleteManager(slotProps.data.id)"
                      :loading="deletingManagerId === slotProps.data.id"
                    >
                    </Button>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
        </section>
      </div>
    </Panel>
  </div>
</template>

<script lang="ts">
import { computed, ref } from "vue";
import AuthRepository from "@/services/AuthRepository";
import { useToast } from "@/ui/services/toast";
import { useRouter } from "vue-router";
import { Register } from "../models/register";
import { useStore } from "vuex";
import TeamRepository from "../services/TeamRepository";
import { Team } from "@/models/team.models";
import { ListCustomer } from "@/models/listCustomer";
import ZaloRepository from "@/services/ZaloRepository";
import { EmployeeCreate } from "@/models/employeeCreate";
import zaloRepository from "@/services/ZaloRepository";
import { GroupCreate } from "@/models/groupCreate";
import teamRepository from "../services/TeamRepository";
import { Group } from "@/models/group";
import { MemberInGroupCreate } from "@/models/memberInGroupCreate";
import { MemberInGroup } from "@/models/memberInGroup";
import { ManagerFeedbackCreate } from "@/models/managerFeedbackCreate";
import { ManagerFeedback } from "@/models/managerFeedback";
import { FilterMatchMode } from "@/ui/services/api";

export default {
  setup() {
    const router = useRouter();
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const listCustomer = ref([] as ListCustomer[]);
    const managerFb = ref({} as ManagerFeedbackCreate);
    const listManagerFb = ref([] as ManagerFeedback[]);
    const isLoading = ref(false);
    const addingManager = ref(false);
    const deletingManagerId = ref<number | null>(null);

    const loadListMember = () => {
      zaloRepository
        .getListCustomer()
        .then((response) => {
          listCustomer.value = response.data;
          loadListManager();
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: "Lỗi khi tải danh sách công dân",
            life: 2000,
          });
        });
    };

    loadListMember();

    const loadListManager = () => {
      isLoading.value = true;
      zaloRepository
        .getListManagerFeedback()
        .then((response) => {
          listManagerFb.value = response.data;
          listManagerFb.value.forEach((x) => {
            listCustomer.value.filter((y) => {
              if (y.id == x.zaloId) x.imageLink = y.imageUrl;
            });
          });
          console.log(
            "@@################### loadListManager listManagerFb : " +
              JSON.stringify(listManagerFb.value),
          );
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: "Lỗi khi tải danh sách nhận góp ý",
            life: 2000,
          });
        })
        .finally(() => {
          isLoading.value = false;
        });
    };

    const addMember = () => {
      addingManager.value = true;
      listCustomer.value.forEach((x) => {
        if (x.id == managerFb.value.zaloId) {
          managerFb.value.zaloName = x.name;
        }
      });
      zaloRepository
        .addManagerFeedback(managerFb.value)
        .then((response) => {
          toast.add({
            severity: "success",
            summary: "Thành công",
            detail: "Thêm thành viên vào nhóm thành công",
            life: 2000,
          });
          loadListManager();
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response.data,
            life: 2000,
          });
        })
        .finally(() => {
          addingManager.value = false;
        });
    };

    const deleteManager = (id: number) => {
      deletingManagerId.value = id;
      zaloRepository
        .deleteManagerFeedback(id)
        .then((response) => {
          toast.add({
            severity: "success",
            summary: "Thành công",
            detail: "Xóa thành viên ra khỏi nhóm thành công",
            life: 2000,
          });
          loadListManager();
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response.data,
            life: 2000,
          });
        })
        .finally(() => {
          deletingManagerId.value = null;
        });
    };
    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    };

    return {
      error,
      managerFb,
      listCustomer,
      addMember,
      deleteManager,
      listManagerFb,
      filters,
      clearFilter,
      initFilters,
      isLoading,
      addingManager,
      deletingManagerId,
    };
  },
};
</script>
